class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '[data-slider]',
      mediaItem: '[data-media-id]',
      modalOpeners: '[data-modal-opener-id]',
      zoomImages: 'a[data-product-zoom]',
      btnXr: '[data-shopify-xr]'
    };
    this.selectedMediaIndex =
      Number(
        this.querySelector(this.selectors.slider).querySelector(
          '[data-selected]'
        )?.dataset.index
      ) || 0;

    const swiperOptions = JSON.parse(
      this.querySelector(this.selectors.slider).getAttribute(
        'data-swiper-options'
      )
    );

    const withThumbs = this.dataset.withThumbs;

    if (withThumbs === 'true') {
      let setWrapperStyles = function (swiper) {
        let wrapperCenterClass = 'swiper-wrapper__center';
        let buttonDisabledClass = swiper.params.buttonDisabledClass;
        let wrapperEl = swiper.wrapper[0];

        if (
          swiper.prevButton[0].classList.contains(
            buttonDisabledClass
          ) &&
          swiper.nextButton[0].classList.contains(buttonDisabledClass)
        ) {
          // center slides
          wrapperEl.classList.add(wrapperCenterClass);
        } else {
          wrapperEl.classList.remove(wrapperCenterClass);
        }
      };
    }   

    this.settings = {
      sliderElement: this.querySelector(this.selectors.slider),
      sliderInstance: null,
      options: {
        initialSlide: 0,
        navigation: {
          prevEl: this.querySelector('.swiper-button--prev'),
          nextEl: this.querySelector('.swiper-button--next')
        },

        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar'
        },

        spaceBetween: 2,
        watchOverflow: true,

        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,

        autoHeight: this.dataset.autoHeight === 'true',        
        

        on: {
          afterInit: swiper => {
            const isSwiperGenerated =
              swiper.slides.length > 1 ? true : false;

            if (isSwiperGenerated) {
              const firstSlide = swiper.slides[0];

              const firstSlideVideo =
                firstSlide.querySelector('video');

              if (firstSlideVideo) {
                this.playPromise(firstSlideVideo);
              }

              // if firstSlide has youtube, play it
              const firstSlideYoutube =
                firstSlide.querySelector('.js-youtube');
              if (firstSlideYoutube) {
                this.playYoutubeVideo(firstSlideYoutube);
              }

              // if firstSlide has vimeo, play it
              const firstSlideVimeo =
                firstSlide.querySelector('.js-vimeo');
              if (firstSlideVimeo) {
                this.playVimeoVideo(firstSlideVimeo);
              }
            }
          },

          slideChangeTransitionEnd: swiper => {
            this.setActiveModalOpener(swiper);
          },
          transitionStart: swiper => {
            const videos = swiper.el.querySelectorAll('video');
            Array.from(videos).forEach(video => {
              video.pause();
            });
          },
          transitionEnd: swiper => {


            const isSwiperGenerated =
              swiper.slides.length > 1 ? true : false;

            if (isSwiperGenerated) {
              let slideIndex = swiper.activeIndex;

              const swiperCardWidth = swiper.slides[0].offsetWidth;

              slideIndex = Math.abs(
                Math.floor(swiper.translate / [swiperCardWidth])
              );

              const activeSlide = Array.from(swiper.slides).find(
                sliderSlide =>
                  sliderSlide.classList.contains(
                    'swiper-slide-active'
                  )
              );

              // play or pause videos in active and next slides
              const activeSlideVideo =
                activeSlide.querySelector('video');
              const nextSlideVideo =
                activeSlide.nextElementSibling?.querySelector(
                  'video'
                );

              const playVideo = video => {
                if (video && video.paused) {
                  this.playPromise(video);
                } else if (video) {
                  video.pause();
                }
              };

              playVideo(activeSlideVideo);
              playVideo(nextSlideVideo);

              const activeSlideYoutube =
                activeSlide.querySelector('.js-youtube');
              if (activeSlideYoutube) {
                this.playYoutubeVideo(activeSlideYoutube);
              }

              const activeSlideVimeo =
                activeSlide.querySelector('.js-vimeo');
              if (activeSlideVimeo) {
                this.playVimeoVideo(activeSlideVimeo);
              }
            }
          }
        }
      }
    };

    if (withThumbs === 'true') {
      const thumbSettings = {
        swiper: {
          el: '.swiper-thumbs',

          initialSlide: this.selectedMediaIndex,

          centeredSlides: true,
          centeredSlidesBounds: true,
          // slideToClickedSlide: true,
          freeMode: {
            enabled: true,
            sticky: true
          },
          direction: 'horizontal',

          slidesPerView: 6,
          spaceBetween: 2,

          threshold: 5,

          watchOverflow: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,

          breakpoints: {
            750: {
              direction: swiperOptions.thumbsDirectionDesktop,
              spaceBetween: 5
            }
          },

          on: {
            touchEnd: function (s, e) {
              let range = 5;
              let diff = (s.touches.diff = s.isHorizontal()
                ? s.touches.currentX - s.touches.startX
                : s.touches.currentY - s.touches.startY);
              if (diff < range || diff > -range) s.allowClick = true;
            }
          }
        }
      };

      this.settings.options.thumbs = thumbSettings;
      this.settings.options.breakpoints = {
        990: {
          slidesPerView: swiperOptions.slidesPerViewDesktop
        }
      };

      // Add the thumbs-specific event handlers
      this.settings.options.on.init = swiper => {
        setTimeout(() => {
          swiper.thumbs.swiper.el.classList.add(
            'swiper-thumbs--visible'
          );
        }, 10);
      };

      this.settings.options.on.slideChangeTransitionStart =
        swiper => {
          const thumbsSwiper = swiper.thumbs.swiper;
          const activeIndex = swiper.activeIndex;
          const thumbsActiveIndex = thumbsSwiper.activeIndex;
          if (activeIndex !== thumbsActiveIndex) {
            thumbsSwiper.slideTo(activeIndex);
          }
        };
    } else {
      this.settings.options.slidesPerView = 1;
    }
  }

  playPromise(video) {
    let playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          // Automatic playback started!
          // Show playing UI.
          // video.play();
        })
        .catch(error => {
          // Auto-play was prevented
          // Show paused UI.
          video.pause();
        });
    }
  }

  playYoutubeVideo(element) {
    element.contentWindow.postMessage(
      '{"event":"command","func":"' + 'playVideo' + '","args":""}',
      '*'
    );
  }

  playVimeoVideo(element) {
    element.contentWindow.postMessage('{"method":"play"}', '*');
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (this.dataset.zoomEnabled === 'true') {
      this.initZoom();
    }

    this.addEventListener('dragstart', event => {
      event.preventDefault();
    });


    //disable Slider for desktop
    const isMobile = window.innerWidth < mobileWidth;
    if(!isMobile){
      return;
    }
    
    if (!this.settings.sliderElement) return;

    this.settings.sliderInstance = new Swiper(
      this.settings.sliderElement,
      this.settings.options
    );


  }

  initZoom() {
    if (
      typeof PhotoSwipeLightbox === 'undefined' ||
      typeof PhotoSwipe === 'undefined' ||
      !this.settings.sliderElement
    ) {
      return;
    }

    const closeIcon = this.querySelector('[data-close-icon]');
    const prevIcon = this.querySelector('[data-prev-icon]');
    const nextIcon = this.querySelector('[data-next-icon]');

    const isPhone = () => window.innerWidth < mobileWidth;
    const hasThumbnails =
      this.querySelectorAll(this.selectors.zoomImages).length > 1;

    this.zoomLightbox = new PhotoSwipeLightbox({
      gallery: `#${this.settings.sliderElement.id}`,
      children: this.selectors.zoomImages,
      mainClass: 'pswp--product-zoom',
      bgOpacity: 1,
      loop: true,
      counter: false,
      showHideAnimationType: 'fade',
      imageClickAction: 'zoom-or-close',
      // keep close button and thumbnails visible on touch; tap zooms instead
      tapAction: 'zoom',
      doubleTapAction: 'zoom',
      // leave room for the close button (top) and thumbnail strip (bottom)
      paddingFn: () => {
        const bottom = hasThumbnails ? (isPhone() ? 96 : 120) : 24;
        return isPhone()
          ? { top: 64, bottom, left: 0, right: 0 }
          : { top: 72, bottom, left: 100, right: 100 };
      },
      initialZoomLevel: 'fit',
      // click (desktop) or double-tap (mobile) zooms to at least full resolution
      secondaryZoomLevel: zoomLevelObject =>
        Math.max(1, zoomLevelObject.fit * 2.5),
      maxZoomLevel: zoomLevelObject =>
        Math.max(2, zoomLevelObject.fit * 4),
      pswpModule: PhotoSwipe
    });

    this.zoomLightbox.addFilter('uiElement', (element, data) => {
      if (data.name === 'close' && closeIcon) {
        element.innerHTML = closeIcon.innerHTML;
      } else if (data.name === 'arrowPrev' && prevIcon) {
        element.innerHTML = prevIcon.innerHTML;
      } else if (data.name === 'arrowNext' && nextIcon) {
        element.innerHTML = nextIcon.innerHTML;
      }
      return element;
    });

    this.zoomLightbox.addFilter('domItemData', (itemData, element, linkEl) => {
      itemData.thumbSrc = linkEl.dataset.pswpThumb || itemData.msrc;
      return itemData;
    });

    if (hasThumbnails) {
      this.zoomLightbox.on('uiRegister', () => {
        this.zoomLightbox.pswp.ui.registerElement({
          name: 'thumbnails',
          className: 'pswp__thumbnails',
          appendTo: 'root',
          onInit: (el, pswp) => this.initZoomThumbnails(el, pswp)
        });
      });
    }

    // pause inline videos while the zoom viewer is open
    this.zoomLightbox.on('beforeOpen', () => {
      this.querySelectorAll('video').forEach(video => video.pause());
    });

    this.zoomLightbox.init();

    // The GG Product Gallery app opens its own zoom viewer when one of its
    // slides is tapped. Catch the click before it reaches the app (capture
    // phase) and open ours instead, so the image and the button match.
    this.addEventListener(
      'click',
      event => {
        const appSlide = event.target.closest('.pmslider-root .pmslider-slide');
        if (!appSlide || appSlide.querySelector('video, iframe, model-viewer')) {
          return;
        }
        const index = this.getZoomIndexForSrc(
          appSlide.querySelector('img')?.getAttribute('src')
        );
        if (index === -1) return;

        event.preventDefault();
        event.stopPropagation();
        this.openZoom(index);
      },
      true
    );

    this.zoomButton = this.querySelector('[data-product-zoom-open]');
    if (!this.zoomButton) return;

    this.zoomButton.addEventListener('click', () => {
      this.openZoom(this.getZoomStartIndex());
    });

    // The GG Product Gallery app replaces the slider on mobile, mounting its
    // own slides + thumbnail strip inside ours. Keep the button over its
    // image area (not its thumbnails), including when the app re-mounts.
    this.placeZoomButton();
    new MutationObserver(() => this.placeZoomButton()).observe(
      this.settings.sliderElement,
      { childList: true, subtree: true }
    );
  }

  placeZoomButton() {
    const appImageArea = this.querySelector(
      '.pmslider-root .pmslider-own--slides-wrapper'
    );
    const target = appImageArea || this.settings.sliderElement;

    if (this.zoomButton.parentElement !== target) {
      target.appendChild(this.zoomButton);
    }
  }

  openZoom(index) {
    this.zoomLightbox.loadAndOpen(index, {
      gallery: this.settings.sliderElement
    });
  }

  // index of our zoom image with the same file as `src`, ignoring Shopify's
  // size suffix (e.g. photo_750x.jpg -> photo.jpg); -1 when there is none
  getZoomIndexForSrc(src) {
    const fileName = value =>
      (value || '')
        .split('?')[0]
        .split('/')
        .pop()
        .replace(/_\d*x\d*(?=\.\w+$)/, '');
    const target = fileName(src);
    if (!target) return -1;

    return Array.from(this.querySelectorAll(this.selectors.zoomImages)).findIndex(
      link => fileName(link.dataset.pswpSrc) === target
    );
  }

  // open on the image currently in view, otherwise the first image
  getZoomStartIndex() {
    // GG Product Gallery: the image behind its current thumbnail
    const appCurrentImage = this.querySelector(
      '.pmslider-root .pmslider-dots_dot--current img'
    );
    if (appCurrentImage) {
      const index = this.getZoomIndexForSrc(appCurrentImage.getAttribute('src'));
      if (index !== -1) return index;
    }

    const zoomLinks = Array.from(
      this.querySelectorAll(this.selectors.zoomImages)
    );
    const slider = this.settings.sliderInstance;
    const activeSlide = slider ? slider.slides[slider.activeIndex] : null;
    const activeLink = activeSlide?.querySelector(this.selectors.zoomImages);

    return Math.max(0, zoomLinks.indexOf(activeLink));
  }

  initZoomThumbnails(container, pswp) {
    const thumbnails = [];

    for (let index = 0; index < pswp.getNumItems(); index++) {
      const itemData = pswp.getItemData(index);
      const button = document.createElement('button');
      const image = document.createElement('img');

      button.type = 'button';
      button.className = 'pswp__thumbnail';
      button.setAttribute('aria-label', `${index + 1} / ${pswp.getNumItems()}`);
      button.addEventListener('click', () => pswp.goTo(index));

      image.src = itemData.thumbSrc || '';
      image.alt = itemData.alt || '';
      image.draggable = false;

      button.appendChild(image);
      container.appendChild(button);
      thumbnails.push(button);
    }

    const setActiveThumbnail = () => {
      thumbnails.forEach((button, index) => {
        const isActive = index === pswp.currIndex;
        button.classList.toggle('is-active', isActive);
        button.toggleAttribute('aria-current', isActive);
      });

      // scroll the strip only, so the page behind the overlay never moves
      const activeThumbnail = thumbnails[pswp.currIndex];
      if (activeThumbnail) {
        container.scrollTo({
          left:
            activeThumbnail.offsetLeft -
            (container.clientWidth - activeThumbnail.offsetWidth) / 2,
          behavior: 'smooth'
        });
      }
    };

    pswp.on('change', setActiveThumbnail);
    pswp.on('afterInit', setActiveThumbnail);
  }

  setActiveMedia(id) {
    const mediaFound = Array.from(
      this.querySelectorAll(this.selectors.mediaItem)
    ).find(media => Number(media.dataset.mediaId) === id);
    if (!mediaFound) return;
    /*this.settings.sliderInstance.slideTo(
      Number(mediaFound.dataset.index)
    ); */
  }

  setActiveModalOpener(swiper) {
    const activeSlide = swiper.slides.filter(sliderSlide =>
      sliderSlide.classList.contains('swiper-slide-active')
    )[0];
    if (!activeSlide) return;
    const activeMediaId = activeSlide.dataset.mediaId;
    this.querySelector(
      `${this.selectors.modalOpeners}.is-active`
    )?.classList.remove('is-active');
    this.querySelector(
      `${this.selectors.modalOpeners} [data-media-id="${activeMediaId}"]`
    )?.parentElement.classList.add('is-active');
    const isModel = activeSlide.dataset.mediaType === 'model';
    if (!isModel) return;
    const btnXr = this.querySelector(this.selectors.btnXr);
    btnXr.dataset.shopifyModel3dId = activeMediaId;
  }
}

customElements.define('product-media', ProductMedia);
